function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  const VOID = -1;
  const PRIMITIVE = 0;
  const ARRAY = 1;
  const OBJECT = 2;
  const DATE = 3;
  const REGEXP = 4;
  const MAP = 5;
  const SET = 6;
  const ERROR = 7;
  const BIGINT = 8;
  const env = typeof self === 'object' ? self : globalThis;
  const deserializer = ($, _) => {
    const as = (out, index) => {
      $.set(index, out);
      return out;
    };
    const unpair = index => {
      if ($.has(index)) return $.get(index);
      const _$index = _slicedToArray(_[index], 2),
        type = _$index[0],
        value = _$index[1];
      switch (type) {
        case PRIMITIVE:
        case VOID:
          return as(value, index);
        case ARRAY:
          {
            const arr = as([], index);
            for (const index of value) arr.push(unpair(index));
            return arr;
          }
        case OBJECT:
          {
            const object = as({}, index);
            for (const _ref of value) {
              var _ref2 = _slicedToArray(_ref, 2);
              const key = _ref2[0];
              const index = _ref2[1];
              object[unpair(key)] = unpair(index);
            }
            return object;
          }
        case DATE:
          return as(new Date(value), index);
        case REGEXP:
          {
            const source = value.source,
              flags = value.flags;
            return as(new RegExp(source, flags), index);
          }
        case MAP:
          {
            const map = as(new Map(), index);
            for (const _ref3 of value) {
              var _ref4 = _slicedToArray(_ref3, 2);
              const key = _ref4[0];
              const index = _ref4[1];
              map.set(unpair(key), unpair(index));
            }
            return map;
          }
        case SET:
          {
            const set = as(new Set(), index);
            for (const index of value) set.add(unpair(index));
            return set;
          }
        case ERROR:
          {
            const name = value.name,
              message = value.message;
            return as(new env[name](message), index);
          }
        case BIGINT:
          return as(BigInt(value), index);
        case 'BigInt':
          return as(Object(BigInt(value)), index);
      }
      return as(new env[type](value), index);
    };
    return unpair;
  };
  const deserialize = serialized => deserializer(new Map(), serialized)(0);
  const EMPTY = '';
  const _ref5 = {},
    toString = _ref5.toString;
  const keys = Object.keys;
  const typeOf = value => {
    const type = typeof value;
    if (type !== 'object' || !value) return [PRIMITIVE, type];
    const asString = toString.call(value).slice(8, -1);
    switch (asString) {
      case 'Array':
        return [ARRAY, EMPTY];
      case 'Object':
        return [OBJECT, EMPTY];
      case 'Date':
        return [DATE, EMPTY];
      case 'RegExp':
        return [REGEXP, EMPTY];
      case 'Map':
        return [MAP, EMPTY];
      case 'Set':
        return [SET, EMPTY];
    }
    if (asString.includes('Array')) return [ARRAY, asString];
    if (asString.includes('Error')) return [ERROR, asString];
    return [OBJECT, asString];
  };
  const shouldSkip = _ref6 => {
    let _ref7 = _slicedToArray(_ref6, 2),
      TYPE = _ref7[0],
      type = _ref7[1];
    return TYPE === PRIMITIVE && (type === 'function' || type === 'symbol');
  };
  const serializer = (strict, json, $, _) => {
    const as = (out, value) => {
      const index = _.push(out) - 1;
      $.set(value, index);
      return index;
    };
    const pair = value => {
      if ($.has(value)) return $.get(value);
      let _typeOf = typeOf(value),
        _typeOf2 = _slicedToArray(_typeOf, 2),
        TYPE = _typeOf2[0],
        type = _typeOf2[1];
      switch (TYPE) {
        case PRIMITIVE:
          {
            let entry = value;
            switch (type) {
              case 'bigint':
                TYPE = BIGINT;
                entry = value.toString();
                break;
              case 'function':
              case 'symbol':
                if (strict) throw new TypeError('unable to serialize ' + type);
                entry = null;
                break;
              case 'undefined':
                return as([VOID], value);
            }
            return as([TYPE, entry], value);
          }
        case ARRAY:
          {
            if (type) return as([type, [...value]], value);
            const arr = [];
            const index = as([TYPE, arr], value);
            for (const entry of value) arr.push(pair(entry));
            return index;
          }
        case OBJECT:
          {
            if (type) {
              switch (type) {
                case 'BigInt':
                  return as([type, value.toString()], value);
                case 'Boolean':
                case 'Number':
                case 'String':
                  return as([type, value.valueOf()], value);
              }
            }
            if (json && 'toJSON' in value) return pair(value.toJSON());
            const entries = [];
            const index = as([TYPE, entries], value);
            for (const key of keys(value)) {
              if (strict || !shouldSkip(typeOf(value[key]))) entries.push([pair(key), pair(value[key])]);
            }
            return index;
          }
        case DATE:
          return as([TYPE, value.toISOString()], value);
        case REGEXP:
          {
            const source = value.source,
              flags = value.flags;
            return as([TYPE, {
              source,
              flags
            }], value);
          }
        case MAP:
          {
            const entries = [];
            const index = as([TYPE, entries], value);
            for (const _ref8 of value) {
              var _ref9 = _slicedToArray(_ref8, 2);
              const key = _ref9[0];
              const entry = _ref9[1];
              if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry)))) entries.push([pair(key), pair(entry)]);
            }
            return index;
          }
        case SET:
          {
            const entries = [];
            const index = as([TYPE, entries], value);
            for (const entry of value) {
              if (strict || !shouldSkip(typeOf(entry))) entries.push(pair(entry));
            }
            return index;
          }
      }
      const message = value.message;
      return as([TYPE, {
        name: type,
        message
      }], value);
    };
    return pair;
  };
  const serialize = function (value) {
    let _ref0 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      json = _ref0.json,
      lossy = _ref0.lossy;
    const _ = [];
    return serializer(!(json || lossy), !!json, new Map(), _)(value), _;
  };
  if (typeof structuredClone !== "function") {
    env.structuredClone = function structuredClone(value) {
      return deserialize(serialize(value));
    };
  }
})();
//# sourceMappingURL=structuredClone.js.map
